import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../api";
import "./css/dsgvo.css";

function DSGVO() {

    const [legal, setLegal] = useState(null);

    useEffect(() => {
        document.title = "Datenschutzerklärung | James Schreiber Portfolio";
    }, []);

    useEffect(() => {
        async function loadLegal() {
            try {
                const response = await fetch(`${API_BASE_URL}/api/legal`);
                const data = await response.json();
                setLegal(data);
            } catch (error) {
                console.error("Fehler beim Abrufen der Datenschutzerklärung:", error);
            }
        }

        loadLegal();
    }, []);

    const privacy = legal?.pages?.privacy;
    const owner = legal?.owner;

    return (

        <React.Fragment>
            <div className="feat-dsgvo">
                <section className="datenschutz">
                    <h1>Datenschutzerklärung</h1>
                    <p>{privacy?.intro || "Die Datenschutzerklärung konnte nicht geladen werden."}</p>

                    <h4>Verantwortliche Stelle</h4>
                    <p>
                        {owner?.responsiblePerson || owner?.name}<br />
                        {owner?.street}<br />
                        {owner?.zip} {owner?.city}<br />
                        {owner?.country}
                    </p>
                    <p>
                        E-Mail: <a href={`mailto:${owner?.email}`}>{owner?.email}</a><br />
                        Telefon: <a href={`tel:${owner?.phone}`}>{owner?.phone}</a>
                    </p>

                    <h4>Datenspeicherung und -verarbeitung</h4>

                    <p>
                        Auf dem Server werden ausschließlich Daten gespeichert, die für den Betrieb der Anwendung erforderlich sind:
                    </p>

                    <ul>
                        {(privacy?.accountData || []).map((item) => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>

                    <p>
                        Eine darüber hinausgehende Speicherung personenbezogener Daten erfolgt nicht, sofern sie nicht für den genannten Zweck notwendig ist.
                    </p>

                    <p>
                        Auf Ihrem Endgerät werden technisch notwendige Daten im Local Storage gespeichert:
                    </p>

                    <ul>
                        {(privacy?.localStorageData || []).map((item) => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>

                    <p>
                        Diese Daten dienen ausschließlich der Bereitstellung der grundlegenden Funktionalität meiner Anwendung.
                    </p>

                    <h4>Zweck und Rechtsgrundlage</h4>
                    <p>{privacy?.purpose}</p>
                    <p>{privacy?.legalBasis}</p>

                    <h4>Speicherdauer</h4>
                    <p>{privacy?.retention}</p>

                    <h4>Löschung von Daten</h4>

                    <p>
                        {privacy?.deletion}
                    </p>

                    <h4>Keine Weiterverarbeitung oder Weitergabe</h4>

                    <p>
                        {privacy?.sharing}
                    </p>

                    <h4>Betroffenenrechte</h4>
                    <p>{privacy?.rights}</p>

                    <h4>Beschwerderecht</h4>
                    <p>{privacy?.supervisoryAuthority}</p>
                </section>



            </div>

            <footer className="footer">
                <div className="footer-container">





                    <div className="footer-right">
                        <Link to="/">Home</Link>
                    </div>

                    <div className="footer-center">
                        © {new Date().getFullYear()} {owner?.website || "James-Schreiber.de"}
                    </div>

                    <div className="footer-right">
                        {legal?.pages?.imprint?.visible !== false && <Link to="/impressum">Impressum</Link>}
                    </div>

                </div>
            </footer>

        </React.Fragment>

    );
}

export default DSGVO;
